'use client';
import { useCustomer } from '@hooks/customer';
import Unauthed from '@views/Account/_Unauthed';
import type { ReactNode } from 'react';

interface AccountClientBoundaryProps {
  children?: ReactNode;
}

const AccountClientBoundary = ({ children }: AccountClientBoundaryProps) => {
  const { data: user } = useCustomer();

  return !user ? <Unauthed /> : <>{children}</>;
};

export default AccountClientBoundary;
